import $ from 'jquery';

import isTouch from '../util/touch';

import initSectionModels from './model';
import productNativeVideo from './native-video-player';
import embedYoutube from './youtube-player';

var selectors = {
  // productImages: '[data-product-images]',
  productSlideshow: '[data-product-slideshow]',
  productThumbs: '[data-product-thumbs]',
  thumbImage: '[data-slideshow-thumbnail]',
  productImage: '[data-product-image]',
  mediaSlide: '[data-media-slide]',
  dataMediaId: 'data-media-id',
  mediaType: 'data-type',
  videoPlayerExternal: '[data-type="external_video"]',
  videoPlayerNative: '[data-type="video"]',
  modelViewer: '[data-type="model"]',
  allPlayers: '[data-player]',
  xrButton: '[data-shopify-xr]',
  xrButtonId: 'data-shopify-model3d-id',
  loopVideo: 'data-enable-video-looping',
  flickitylockHeight: 'flickity-lock-height',
  alignment: 'data-thumbs-align',
};

class Media {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.$container = $(section.container);
    this.slideshow = this.container.querySelector(selectors.productSlideshow);
    this.thumbWrapper = this.container.querySelector(selectors.productThumbs);
    this.thumbImages = this.container.querySelectorAll(selectors.thumbImage);
    this.loopVideo = this.container.getAttribute(selectors.loopVideo) === 'true';
    this.centerAlign = this.container.getAttribute(selectors.alignment) === 'center';

    this.init();
  }

  init() {
    this.createSlider();
    this.eventListeners();
    this.detectVideo();
    this.detectYouTube();
    this.detect3d();
  }

  createSlider() {
    const $productSlideshow = $(selectors.productSlideshow, this.$container)
    if (!$productSlideshow.length) {
      return;
    }

    const instance = this
    $productSlideshow
      .on('init', function(){
        // $('.media__thumb', this.$container).first().addClass('is-selected');
      })
      .on('beforeChange', function(evt, slick, currentSlide, nextSlide) {
        // console.log('slick beforeChange');
        if( ! instance.$container.find(`[data-product-slideshow-wrap]`).length ) {
          return;
        }
        instance.$container.find(`[data-product-slideshow-wrap]`).attr('data-slick-index', nextSlide);
      })
      .on('afterChange', function(evt, slick, currentSlide) {
        // let mediaId = slick.$slides.filter(`[data-slick-index="${currentSlide}"]`).find('[data-media-slide]').attr('data-media-id');
        // $('.media__thumb', this.$container).removeClass('is-selected');
        // $('.media__thumb', this.$container).filter(`[data-media-select="${mediaId}"]`).addClass('is-selected');
      })
      .slick({
        "arrows": true,
        "dots": true,
        customPaging: function(slider, i) {
          // this example would render "tabs" with titles
          const $media = $(slider.$slides[i]).find(`.product__media`)
          return `<button class="media__thumb"><img src="${$media.attr('data-thumb')}" /></button>`;
        }
      });
  }

  eventListeners() {
    this.slideshow.addEventListener(
      'theme:image:change',
      function (event) {
        const mediaId = event.detail.id
        const formState = event.detail.formState
        const variantTitle = event.detail.variantTitle

        // const $productImages = $(selectors.productImages, this.$container)
        const $productSlideshow = $(selectors.productSlideshow, this.$container)
        const productMediaItemsHtml = $('[product-media-items-object]', this.$container).html()
        const $productMediaItems = $(productMediaItemsHtml)

        let selectedColorValue = false;
        for( let i=0 ; i<formState.options.length ; i++ ) {
          if( formState.options[i].name == 'Color' || formState.options[i].name == 'Colour' ) {
            selectedColorValue = formState.options[i].value
          }
        }

        if( selectedColorValue !== false ) {
          // Dynamic slider - delete all media, construct again from json object and reinit
          let matchingAltTags = ['All', selectedColorValue, variantTitle]

          // Reset images
          // $productImages.html('');
          if ( $productSlideshow.length ) {
            $productSlideshow.slick('unslick')
          }
          $productSlideshow.html('')
          $productMediaItems.each(function(){
            const $item = $(this)
            const itemAlt = $item.attr('data-alt')
            for( let i=0 ; i<matchingAltTags.length ; i++ ) {
              if( matchingAltTags[i].indexOf(itemAlt) !== -1 ) {
                // $productImages.append( $item.clone() )
                $productSlideshow.append( $item )
                break;
              }
            }
          })
          this.createSlider()
        }

        const $featuredMediaImage = $(`[${selectors.dataMediaId}="${mediaId}"]`)
        if( $featuredMediaImage.length ) {
          const featuredSlickIndex = parseInt( $featuredMediaImage.closest('.slick-slide').attr('data-slick-index') ) || 0
          $productSlideshow.slick('goTo', featuredSlickIndex)
        }
      }.bind(this)
    );

    // this.slideshow.addEventListener(
    //   'theme:image:change',
    //   function (event) {
    //     var mediaId = event.detail.id,
    //         $featuredMediaImage = $(`[${selectors.dataMediaId}="${mediaId}"]`);
    //     if( !$featuredMediaImage.length ) {
    //       return;
    //     }
    //     let $slideSlide = $featuredMediaImage.closest('.slick-slide'),
    //         slickIndex = parseInt( $featuredMediaImage.closest('.slick-slide').attr('data-slick-index') ) || 0;
    //     $(this.slideshow, this.$container).slick('goTo', slickIndex);
    //   }.bind(this)
    // );

    this.thumbImages.forEach((thumb) => {
      thumb.addEventListener(
        'click',
        function (event) {
          const id = event.currentTarget.getAttribute('data-media-select');
          this.slideshow.dispatchEvent(
            new CustomEvent('theme:image:change', {
              detail: {
                id: id,
              },
            })
          );
        }.bind(this)
      );
    });
  }

  sliderThumbs() {
    // let opts = {
    //   freeScroll: true,
    //   contain: true,
    //   prevNextButtons: false,
    //   pageDots: false,
    //   accessibility: true,
    //   cellAlign: this.centerAlign ? 'center' : 'left',
    //   sync: this.slideshow,
    // };
    // this.flktyThumbs = new FlickitySync(this.thumbWrapper, opts);
  }

  confirmSync() {
    // if (this.flkty.selectedIndex !== this.flktyThumbs.selectedIndex) {
    //   this.flkty.resize();
    // }
  }

  setDraggable() {
    // if (this.currentSlide) {
    //   const mediaType = this.currentSlide.getAttribute(selectors.mediaType);

    //   if (mediaType === 'model' || mediaType === 'video' || mediaType === 'external_video') {
    //     // fisrt boolean sets value, second option false to prevent refresh
    //     this.flkty.options.draggable = false;
    //     this.flkty.updateDraggable();
    //   } else {
    //     this.flkty.options.draggable = true;
    //     this.flkty.updateDraggable();
    //   }
    // }
  }

  detect3d() {
    const modelViewerElements = this.container.querySelectorAll(selectors.modelViewer);
    if (modelViewerElements) {
      modelViewerElements.forEach((element) => {
        initSectionModels(element, this.section.id);
      });
      document.addEventListener(
        'shopify_xr_launch',
        function () {
          this.container.querySelectorAll(selectors.allPlayers).forEach((player) => {
            player.dispatchEvent(new CustomEvent('pause'));
          });
        }.bind(this)
      );
    }
  }

  detectVideo() {
    const playerElements = this.section.container.querySelectorAll(selectors.videoPlayerNative);
    for (var player of playerElements) {
      const uniqueKey = player.dataset.player;
      const nativePlayerPromise = productNativeVideo(uniqueKey);
      if (this.loopVideo === true) {
        nativePlayerPromise
          .then((nativePlayer) => {
            nativePlayer.loop = true;
            return nativePlayer;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }

  detectYouTube() {
    const playerElements = this.section.container.querySelectorAll(selectors.videoPlayerExternal);
    for (var player of playerElements) {
      const uniqueKey = player.dataset.player;
      const youtubePlayerPromise = embedYoutube(uniqueKey);
      if (this.loopVideo === true) {
        youtubePlayerPromise
          .then((youtubePlayer) => {
            return _setToLoop(youtubePlayer);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }

  pauseAllMedia() {
    const all = this.container.querySelector(`[data-media-slide]`);
    all.dispatchEvent(new CustomEvent('pause'));
  }

  pauseOtherMedia(uniqueKey) {
    const otherMedia = this.container.querySelector(`[data-media-slide]:not([data-player="${uniqueKey}"])`);
    otherMedia.dispatchEvent(new CustomEvent('pause'));
  }

  destroy() {
    // destroy detect3D
    this.container.querySelectorAll(selectors.allPlayers).forEach((player) => {
      player.dispatchEvent(new CustomEvent('destroy'));
    });
  }
}

function _setToLoop(youtubePlayer) {
  youtubePlayer.addEventListener('onStateChange', function (event) {
    if (event.data === 0) {
      // video is over, replay
      event.target.playVideo();
    }
  });
  return youtubePlayer;
}

export default Media;
